import React from "react";
import "./TagsModal.css";
import { CloseOutlined } from "@ant-design/icons";

const TagsModal = ({ 
    visible, 
    header = "Company Names", 
    companies = [], 
    onClose
    }) => {
    if (!visible) return null;

    return (
        <div className="interactive-map-tags-modal-dropdown">
            <div className="interactive-map-tags-modal-header">
            <h3>{header}</h3>
                <CloseOutlined 
                className="tags-modal-close" 
                onClick={onClose}
                />
            </div>
            <div className="interactive-map-tags-tags">
                {companies.map((name, index) => (
                <span key={index} className="interactive-map-tags-tag">
                    {name}
                </span>
                ))}
            </div>
        </div>
    );
};

export default TagsModal;